import './Label.scss';

export const Label = ({ label, className }: { label: string; className?: string }) => {
  return <div className={`label ${className ?? ''}`.trim()}><span>{label}</span></div>
}